import React from 'react';
import AdminLayout from '../../components/layouts/AdminLayout';
import Notifications from '../customer/Notifications';

// Reuse customer notifications component with admin layout
const AdminNotifications = () => {
  return (
    <AdminLayout>
      <Notifications isAdmin />
    </AdminLayout>
  );
};

export default AdminNotifications;
